import { useTranslation } from 'react-i18next';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEOMeta({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage }: SEOMetaProps) {
  const { t } = useTranslation();

  const fullTitle = `${title} - ${t('siteName')}`;

  // Update document head
  document.title = fullTitle;

  // Update meta tags
  const setMeta = (name: string, content: string, isProperty = false) => {
    const attr = isProperty ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', description);
  setMeta('keywords', keywords);

  const canonicalEl = document.querySelector('link[rel="canonical"]');
  if (canonicalEl) {
    canonicalEl.setAttribute('href', canonicalUrl);
  } else {
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);
  }

  setMeta('og:title', fullTitle, true);
  setMeta('og:description', description, true);
  setMeta('og:type', ogType, true);
  setMeta('og:url', canonicalUrl, true);
  if (ogImage) {
    setMeta('og:image', ogImage, true);
  }

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', fullTitle);
  setMeta('twitter:description', description);
  if (ogImage) {
    setMeta('twitter:image', ogImage);
  }

  return null;
}